// Activity Library taxonomy (OD-1193 — Quick Notes Activity Library).
// Each activity is atomic (one action), reusable across clients, and carries a
// hidden Activity Type used internally for AI note generation, reporting,
// analytics and recommendations — never shown to the DSP.
//
// The actual library items (layer/section/name/type/order/active) come from
// the backend via src/services/activityLibrary.js — nothing here is fake data.

export const ACTIVITY_LAYERS = [
  { key: "common_shift", label: "Common Shift Activities" },
  { key: "care_plan", label: "Care Plan Activities" },
  { key: "support_method", label: "Support Methods" },
];

export const ACTIVITY_TYPES = [
  "Meal",
  "Meal Preparation",
  "Medication",
  "Hygiene",
  "Vitals",
  "Health Monitoring",
  "Sleep",
  "Behavioral Support",
  "Coping Skill",
  "Social Skill",
  "Cognitive Skill",
  "Recreation",
  "Routine Support",
  "Safety",
  "Medical Appointment",
  "Mobility",
  "Physical Activity",
  "Communication",
  "Social Communication",
  "Sensory",
  "Motor Skills",
  "Transportation",
  "Community",
  "Employment",
  "Household",
  "Financial",
  "Driver Education",
  "Prompting",
  "Physical Assistance",
  "Supervision",
];

// Sections that should prompt the DSP for a short free-text response when
// an activity is selected in the Quick Notes picker (kept as data here so
// the picker component doesn't hardcode section names).
export const FREE_TEXT_SECTIONS = ["Health Monitoring", "Community Based Activities"];

// Only Impulse Control activities walk through the Support Method wizard
// (Prompting/Physical Support/Behavioral Support/Safety Support) — every
// other Care Plan Activities section is just checked directly, and
// Community Based Activities (a FREE_TEXT_SECTIONS section) never gets the
// wizard at all.
export const PROMPTING_SECTIONS = ["Impulse Control & Coping Skills"];

// Support-method wizard steps shown after picking a Care Plan Activities item —
// each step's options come from the matching section in SUPPORT_METHOD_LIBRARY.
export const SUPPORT_STEPS = [
  { question: "What prompting was used?", section: "Prompting" },
  { question: "What type of Physical Support was provided?", section: "Physical Support" },
  { question: "What type of behavioral support was provided?", section: "Behavioral Support" },
  { question: "What type of safety support was provided?", section: "Safety Support" },
];

// Support Methods is a fixed interaction vocabulary (reusable modifiers, not
// admin-managed content) — kept hardcoded rather than fetched from the
// backend, unlike Common Shift Activities / Care Plan Activities.
export const SUPPORT_METHOD_LIBRARY = [
  { section: "Prompting", items: ["Verbal Prompt", "Visual Prompt", "Gesture Prompt", "Modeling", "Cueing", "Reminder"] },
  { section: "Physical Support", items: ["Standby Assistance", "Physical Assistance", "Hand-over-Hand Assistance", "Full Assistance", "Partial Assistance", "One-on-One Supervision"] },
  { section: "Behavioral Support", items: ["Positive Reinforcement", "Praise", "Encouragement", "Redirection", "Reassurance", "Emotional Support", "Active Listening", "Calming Techniques"] },
  { section: "Safety Support", items: ["Safety Monitoring", "Close Observation", "Fall Prevention", "Environmental Safety Check", "Choking Prevention", "Medication Safety"] },
];

export const getSupportMethodOptions = (sectionName) =>
  SUPPORT_METHOD_LIBRARY.find((s) => s.section === sectionName)?.items || [];
